import { useState, useEffect } from 'react';
import { ThemeProvider } from './components/ThemeProvider';
import ChatWidget from './components/ChatWidget';
import FloatingChatButton from './components/FloatingChatButton';
import { createTheme } from './types/theme';
import chatService from './api/chatService';
import "@livekit/components-styles";
import { ActiveView, ViewMode } from './types';

interface AppProps {
  initialTheme: "dark" | "light";
  initialColor: string;
  apiKey: string;
  companyName: string;
  agentName: string;
  isVoiceAgentEnabled?: boolean;
}

function App({ initialTheme = "light", initialColor = "#2563eb", apiKey, companyName = "test", agentName = "test" }: AppProps) {
  const [viewMode, setViewMode] = useState<ViewMode>('minimized');
  const [activeView, setActiveView] = useState<ActiveView>('chat');
  const [isOpen, setIsOpen] = useState(false);
  const [currentTheme, setCurrentTheme] = useState(createTheme(initialTheme, initialColor));

  useEffect(() => {
    setCurrentTheme(createTheme(initialTheme, initialColor));
  }, [initialTheme, initialColor]);

  useEffect(() => {
    if (apiKey) {
      chatService.init(apiKey, companyName);
    }
  }, [apiKey, companyName]);

  const handleModeChange = (mode: ViewMode) => {
    setViewMode(mode);
    if (mode === 'minimized') {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  };

  const handleToggleOpen = () => {
    if (viewMode === 'minimized') {
      setViewMode('widget');
      setIsOpen(true);
    } else {
      setIsOpen(!isOpen);
    }
  };

  const handleViewChange = (view: ActiveView) => {
    setActiveView(view);
  };


  if (viewMode === 'minimized') {
    return (
      <ThemeProvider initialTheme={currentTheme}>
        <FloatingChatButton onClick={handleToggleOpen} theme={currentTheme} agent_name={agentName} />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider initialTheme={currentTheme}>
      {isOpen ? (
        <ChatWidget
          viewMode={viewMode}
          activeView={activeView}
          onClose={() => {
            setIsOpen(false);
            setViewMode('minimized');
          }}
          onMinimize={() => handleModeChange('minimized')}
          onViewChange={handleViewChange}
          onFullscreen={() => handleModeChange('fullscreen')}
          theme={currentTheme}
          onThemeChange={setCurrentTheme}
          agentName={agentName}
          companyName={companyName}
        />
      ) : (
        <FloatingChatButton
          onClick={handleToggleOpen}
          theme={currentTheme}
          agent_name={agentName}
        />
      )}
    </ThemeProvider>
  );

}

export default App;